import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import {
  VCard, VCardTitle, VCardSubtitle, VCardText, VCardActions,
  VForm, VTextField, VCheckbox, VTextarea, VAutocomplete,
  VCombobox, VFileInput, VSlider, VRating, VSwitch,
  VRow, VCol, VSpacer, VIcon, VBtn,
} from 'vuetify/lib/components';

Vue.use(Vuetify, {
  components: {
    VCard, VCardTitle, VCardSubtitle, VCardText, VCardActions,
    VForm, VTextField, VCheckbox, VTextarea, VAutocomplete,
    VCombobox, VFileInput, VSlider, VRating, VSwitch,
    VRow, VCol, VSpacer, VIcon, VBtn,
  }
});
Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },

    themes: {
      light: {
        // LIGHT THEME → Orange + White
        primary: "#FA7C10",
        secondary: "#2A2E32",
        accent: "#FF9F4A",

        background: "#dadada",
        surface: "#FFFFFF",

        text: "#2A2E32",
        btnDef: "#FFFFFF",

        success: "#4CAF50",
        error: "#FF5252",
        warning: "#FFC107",
        info: "#29A2FF",

        // Custom utilities
        electricGlow: "#FFB56B",
        neon: "#FF8C00",
      },

      dark: {
        // DARK THEME → Cyan + Dark Blue
        primary: "#00ffff",
        secondary: "#0D1B2A",
        accent: "#38BDF8",

        background: "#0A1420",
        surface: "#00ffff",

        text: "#FA7C10",
        btnDef: "#0A1420",

        success: "#4CAF50",
        error: "#00ffff",
        warning: "#FFC107",
        info: "#29A2FF",

        electricGlow: "#38BDF8",
        neon: "#19E3FF",
      },
    },
  },
});
